import styled from 'styled-components';
import {ButtonPrimary} from 'components/buttons';

export const HelpSubtitle = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  color: #172751;
  margin: 0 0 24px;
`;

export const HelpCards = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;

export const HelpCard = styled.div`
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 8px 16px 0px rgba(221, 221, 221, 0.32);
  padding: 20px 16px;
  min-height: 199px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const HelpCardIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffeef0;
  margin-bottom: 16px;

  &.green {
    background-color: #e7f9f1;
  }
`;

export const HelpCardTitle = styled.h3`
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
  color: #000000;
  margin: 0;
`;

export const HelpCardText = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
  color: #000000;
  margin: 4px 0 20px;
`;

export const HelpCardButton = styled(ButtonPrimary)`
  margin-top: auto;
  text-decoration: none;

  span {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    line-height: 1;
    font-weight: 400;

    svg {
      display: block;
      flex: 0 0 auto;
    }
  }
`;
